







































import {Emit} from 'vue-property-decorator';
import {InOut} from 'vue-inout-prop-decorator';
import {Component, Vue} from '@/shared/component';

import {Client} from '@/models';

import CrudClientEdit from '@/components/Crud/Client/Edit.vue';

@Component({
	components: {
		CrudClientEdit,
	}
})
export default class CrudClientEditDialog extends Vue {
	@InOut({ type: Client  , isVModel: true }) private value!: Client;
	@InOut({ type: Boolean  , isVModel: false }) private route!: Boolean;

	@Emit()
	private onSubmit(client: Client) {
		this.onClose();
	}

	@Emit()
	private onClose() {
		if (this.value.id)
		{
			if (this.route == true) {
				if (
					this.$route.name !== 'client-show' ||
					this.$route.params["id"] !== this.value.id.toString()
				) {
					this.$router.push({name: 'client-show', params: { id : this.value.id.toString() }});
				}
			}
		}
		this.value = null;
	}
}
